export const quoteRsqlValue = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return '""';
  }

  return `"${trimmed.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
};

export const buildIlikeFilter = (field: string, value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return "";
  }

  return `${field}=ilike=${quoteRsqlValue(trimmed)}`;
};

export function buildEqFilter(field: string, value: string): string {
  return `${field}==${value.trim()}`;
}

export function buildInFilter(field: string, values: string[]): string {
  const normalized = values.map((value) => value.trim()).filter(Boolean);
  if (normalized.length === 0) {
    return "";
  }
  if (normalized.length === 1) {
    return buildEqFilter(field, normalized[0]!);
  }
  return `${field}=in=(${normalized.join(",")})`;
}

export function combineSearchFilters(...parts: Array<string | undefined | null>): string | undefined {
  const filters = parts
    .map((part) => part?.trim())
    .filter((part): part is string => Boolean(part));
  return filters.length > 0 ? filters.join(",") : undefined;
}

export function combineAndFilters(...parts: Array<string | undefined | null>): string | undefined {
  const filters = parts
    .map((part) => part?.trim())
    .filter((part): part is string => Boolean(part));
  return filters.length > 0 ? filters.join(";") : undefined;
}

export function combineOrFilters(...parts: Array<string | undefined | null>): string | undefined {
  const filters = parts
    .map((part) => part?.trim())
    .filter((part): part is string => Boolean(part));
  if (filters.length === 0) return undefined;
  if (filters.length === 1) return filters[0];
  return `(${filters.join(",")})`;
}
